import { apiPut, apiPost, apiDelete, apiGet } from '../../generic/Api_Functions'
import SmartMateriaUITable from '../../generic/SmartMateriaUITable'
import { useSmartTranslation } from '../../generic/hooks/useSmartTranslation'
import { systemValueDescription, systemValueLabel, systemValueOptionText } from '../../generic/systemValues/systemValueLabel'

const Reason = () => {
  const { t_ } = useSmartTranslation()

  const columns = [
    {
      name: t_('Code'),
      field: 'code',
      charLimit: 60,
      mandatory: true,
      unique: true,
      readOnly: (row) => {
        return row.systemDefault
      }
    },
    {
      name: t_('Name'),
      field: 'name',
      render: (row) => systemValueLabel(t_, 'reason', row),
      renderOnlyInReadMode: true,
      charLimit: 80,
      mandatory: true,
      unique: true,
      readOnly: (row) => {
        return row.systemDefault
      }
    },
    {
      name: t_('Description'),
      field: 'description',
      charLimit: 200,
      // P10: a seeded row's description is factory text and reads translated; a customer row keeps its own.
      render: (row) => systemValueDescription(t_, 'reason', row),
      renderOnlyInReadMode: true
    },
    {
      name: t_('Reason Type'),
      field: 'reasonType.name',
      render: (row) => systemValueLabel(t_, 'reason_type', row.reasonType),
      renderOnlyInReadMode: true,
      filterByLabel: { options: (items) => items.map((item) => ({ value: item.name, label: systemValueLabel(t_, 'reason_type', item) })) },
      type: 'smartSelect',
      edit: {
        source: async () => {
          return await apiGet('reasonTypesShortData')
        },
        id: 'id',
        field: 'name',
        optionLabel: (name, items) => systemValueOptionText(t_, 'reason_type', items, name)
      },
      mandatory: true,
      readOnly: (row) => {
        return row.systemDefault
      }
    }
  ]

  const actions = {
    create: {
      fetchFunction: (row) => apiPost('reason', row)
    },
    edit: {
      fetchFunction: (row) => apiPut('reason', row)
    },
    delete: {
      fetchFunction: (rows) => {
        if (rows.length === 1) {
          return apiDelete('reason/' + rows[0].id)
        } else {
          return apiDelete('reasonMulti', rows)
        }
      },
      visibilityButton: (row) => {
        return !row.systemDefault
      }
    }
  }

  return (
    <SmartMateriaUITable
      tableTuneUniqueKey='reason'
      columns={columns}
      title={t_('Reasons')}
      dataFetch='reasons'
      actions={actions}
      pageable
      multipleSelection
      safeDeleteShowProperty='name'
    />
  )
}

export default Reason
